const config = {
  stripEmail: /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi,
}

export default function(searchTerm) {
  if (!searchTerm) return searchTerm
  return searchTerm.replace(config.stripEmail, '')
}
